/* globals Class, $H, lp, jui, editor */
var _ = require('lodash');

var rxUi = window.rxUi;

lp.editor.ImageTransformBoxHandle = Class.create( jui.Component, {
  _handleNames: ['tlh','trh','blh','brh','tmh','rmh','bmh','lmh'],

  options: function($super,options){
    return $super($H({
      attributes:{className:'transform-handle'},
      snap:true}).merge(options));
  },

  initialize: function( $super, box, callbacks, handleName, routingKey){
    this._routingKey = routingKey || 'ImageTransformBoxHandle';
    if (!_.contains(this._handleNames, handleName)) {
      throw new Error('invalid image transform handle name: ' + handleName);
    }
    this.name = handleName;

    $super({classNames: [handleName, 'transform-handle-'+handleName]});
    this.box = box;
    this.onDrag = callbacks.onDrag;
    this.onInitDrag = callbacks.onInitDrag;
    this.onBeforeDrag = callbacks.onBeforeDrag;
  },

  handleEvent: function(ev) {
    var self = this;
    //TODO: refactor this into a proper multimethod definition
    var domainEvent = {
      startDrag: function(ev) {
        self.startLeft = self.box.getStartLeft();
        self.startTop = self.box.getStartTop();
        self.startWidth = self.box.getStartWidth();
        self.startHeight = self.box.getStartHeight();
        self.startPoint = new jui.Point(Event.pointerX(ev), Event.pointerY(ev));
        self.onInitDrag(self.box.getModel());
        self.box.tracking = true;
        self.fireEvent('startMove', self.elm);
      },

      drag: function(ev) {
        self.onBeforeDrag();
        var p = new jui.Point(Event.pointerX(ev), Event.pointerY(ev)).subtract(self.startPoint);
        var p2 = p.clone().add(self.initPoint);
        var p3 = p2.clone();
        if (self.options.snap){
          editor.snapManager.snapPoint(p3);
        }
        if (self.box.elm) {
          // We sometimes see drag events after endDrag and the elm is
          // null. It might be redo/undo related. Can't repro it.
          self.onDrag(p.add(p3.subtract(p2)), self.box.elm.model);
        }
      },

      endDrag: function() {
        self.box.undoRegistered = false;
        self.box.tracking = false;
        self.fireEvent('stopMove', self.elm);
      }
    };
    var handler = domainEvent[ev.type];
    if (typeof handler === 'function') {
      handler(ev);
    }
  },

  installUI: function($super, options) {
    $super( options );
    this._uiBinding = new rxUi.Binding([this._routingKey, this.name]);
    this._uiBinding.bindDrag(this.e).ub_subscribe(this.handleEvent.bind(this));
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/image_transform_box_handle.js
// module id = 1030
// module chunks = 0